export const IconPlus = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M18.125 10.0002C18.125 10.5178 17.7051 10.9377 17.1875 10.9377H10.9375V17.1877C10.9375 17.7053 10.5176 18.1252 10 18.1252C9.48242 18.1252 9.0625 17.7053 9.0625 17.1877V10.9377H2.8125C2.29492 10.9377 1.875 10.5178 1.875 10.0002C1.875 9.48267 2.29492 9.06274 2.8125 9.06274H9.0625V2.81274C9.0625 2.29517 9.48242 1.87524 10 1.87524C10.5176 1.87524 10.9375 2.29517 10.9375 2.81274V9.06274H17.1875C17.7051 9.06274 18.125 9.48267 18.125 10.0002Z" fill="white" />
  </svg>
);

// For closing modals or popups
export const IconCross = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="#6E7E92"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.2698 5.21726C5.97931 4.92758 5.50835 4.92758 5.21786 5.21726C4.92738 5.50693 4.92738 5.97659 5.21786 6.26626L9.15496 10.1924L5.21786 14.1185C4.92738 14.4082 4.92738 14.8778 5.21786 15.1675C5.50835 15.4572 5.97931 15.4572 6.2698 15.1675L10.2069 11.2414L14.1438 15.1674C14.4343 15.457 14.9053 15.457 15.1958 15.1674C15.4862 14.8777 15.4862 14.408 15.1958 14.1184L11.2588 10.1924L15.1958 6.26641C15.4862 5.97674 15.4862 5.50708 15.1958 5.21741C14.9053 4.92773 14.4343 4.92773 14.1438 5.21741L10.2069 9.14338L6.2698 5.21726Z"
      fill="#currentColor"
    />
  </svg>
);